import React from 'react';
import { Modal } from 'antd';
import { CustomWorkflowForm } from './WorkflowForm';

interface WorkflowModalProps {
	open: boolean;
	onClose: () => void;
	type: string;
	editingWorkflow?: any;
}

export const WorkflowModal: React.FC<WorkflowModalProps> = ({
	open,
	onClose,
	type,
	editingWorkflow,
}) => {
	const handleSave = (_data: any) => {
		onClose();
	};

	const handleCancel = () => {
		onClose();
	};

	return (
		<Modal
			open={open}
			onCancel={onClose}
			footer={null}
			width={800}
			centered
			destroyOnClose
			title={null}
			className="workflow-modal"
		>
			<CustomWorkflowForm
				type={type}
				onCancel={handleCancel}
				onSave={handleSave}
				editingWorkflow={editingWorkflow}
			/>
		</Modal>
	);
};
